import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import styles from '../DesktopTabletView/DesktopTableView.module.scss';
import Skeleton from '@app/components/common/Blocks/Skeleton/Skeleton';

const DEFAULT_DESKTOP_SKELETON_HEIGHT = 32;
const DEFAULT_MOBILE_SKELETON_HEIGHT = 24;

export const DisplaySkeleton = ({
  className = '',
  skeletonHeight,
  columnSize
}) => {
  return (
    <div className={`row gx-0 ${className}`}>
      <div className={`col-${columnSize}`}>
        <Skeleton
          heightInPx={skeletonHeight}
          data-testid="equipmentInfoLoader"
        />
      </div>
    </div>
  );
};

const EquipmentInfoLoader = ({ hasNoEquipmentInfo }) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const userType = useSelector(s => s.common?.userType);
  const isLoggedIn = userType !== null && userType !== 'G';

  const equipmentImageLoader = (
    <>
      <div className="d-none d-md-block pe-3">
        <Skeleton heightInPx={160} />
      </div>
      <div className="d-md-none">
        <DisplaySkeleton className="mb-2" skeletonHeight={48} columnSize="12" />
        <DisplaySkeleton
          className={!isLoggedIn ? 'mb-2' : 'mb-0'}
          skeletonHeight={104}
          columnSize="12"
        />
        {!isLoggedIn && (
          <>
            <hr />
            <DisplaySkeleton
              skeletonHeight={DEFAULT_MOBILE_SKELETON_HEIGHT}
              columnSize="12"
            />
            <hr className="mb-0" />
          </>
        )}
      </div>
    </>
  );
  const getEquipmentDetailLoader = () => {
    return !isMD ? (
      equipmentImageLoader
    ) : (
      <>
        <div className="row gx-0 ps-3 pt-3 pe-2 pb-2">
          <div className="col-11 pe-3">
            <Skeleton heightInPx={32} />
          </div>
          <div className="col-1">
            <Skeleton heightInPx={32} />
          </div>
        </div>
        <DisplaySkeleton
          className="pb-2 ps-3"
          skeletonHeight={32}
          columnSize="4"
        />
        <DisplaySkeleton
          className="ps-3  mb-2 pe-2"
          skeletonHeight={48}
          columnSize="12"
        />
        {(!isLoggedIn || hasNoEquipmentInfo) && (
          <>
            <hr />
            <DisplaySkeleton
              className={'pb-3 ps-3 pe-2'}
              skeletonHeight={DEFAULT_DESKTOP_SKELETON_HEIGHT}
              columnSize="12"
            />
          </>
        )}
      </>
    );
  };

  return (
    <section
      className={`row gx-0 ${styles['c-alp-equipment-info-desk']} ${
        isMD ? 'my-2' : 'mt-2'
      }`}
      data-testid="equipmentInfoLoader"
    >
      <div className="col-12 col-md-3 col-blg-4">{equipmentImageLoader}</div>
      <div
        className={`d-none d-md-block col-auto col-md-9 col-blg-8  ${styles['c-alp-equipment-info-desk--details-wrapper']}`}
      >
        {getEquipmentDetailLoader()}
      </div>
    </section>
  );
};

EquipmentInfoLoader.propTypes = {
  hasNoEquipmentInfo: PropTypes.string
};
DisplaySkeleton.propTypes = {
  className: PropTypes.string,
  skeletonHeight: PropTypes.number,
  columnSize: PropTypes.string
};

export default EquipmentInfoLoader;
